/* eslint-disable no-restricted-properties */
const ONE_DAY_MILLISECONDS = 1000 * 60 * 60 * 24;

/*
 * Annualized Returns Service
 *
 * Formula:
 *
 * (( end period value / start period value ) ** ( 365 / days in period ) - 1) * 100
 *
 *
 * Normalized:
 *
 * startVal = 1
 * endVal = (percentChange / 100) + 1
 */
export class AnnualizedReturnsService {
    static daysBetween(startDate: number, endDate: number): number {
        return Math.round((endDate - startDate) / ONE_DAY_MILLISECONDS);
    }

    static getYearsBack(startDate: number, endDate: number): number {
        const startDateYear = new Date(startDate).getFullYear();
        const endDateYear = new Date(endDate).getFullYear();
        const wholeYearsBack = endDateYear - startDateYear;
        const copiedStartDate = new Date(startDate);
        copiedStartDate.setFullYear(endDateYear);
        const daysDifference = this.daysBetween(copiedStartDate.getTime(), endDate);
        const yearFraction = daysDifference === 0 ? 0 : daysDifference / 365.242374;
        return wholeYearsBack + yearFraction;
    }

    // Returns the numeric `NaN` when either value is negative (annualization is skipped);
    // otherwise a `.toFixed(2)` string (which is `'NaN'` when the computation is undefined).
    static annualizeReturns(startDate: number, startVal: number, endDate: number, endVal: number): string | number {
        // If either values are < 0 do not annualize
        if (startVal < 0 || endVal < 0) return NaN;
        const yearsBack = this.getYearsBack(startDate, endDate);
        return (((endVal / startVal) ** (1 / yearsBack) - 1) * 100).toFixed(2);
    }

    static annualizeNormalizedReturns(startDate: number, percentChange: number, endDate: number): string | number {
        const startVal = 1;
        const endVal = percentChange / 100 + 1;
        return this.annualizeReturns(startDate, startVal, endDate, endVal);
    }
}
